import { createSelector } from 'reselect';

import { ActionRef } from '@/App/types/actionRef';
import { ScreenRef } from '@/App/types/screenRef';
import { selectDisplayRuleStateMap } from '@/features/displayRules/selectDisplayRuleStateMap';
import { selectScreenRefDataMap } from '@/features/refdata/selectScreenRefDataMap';
import ExpEngine from '@/services/ExpEngine';

export const selectPageFragmentInitialized = (screen: ScreenRef, action: ActionRef) =>
  createSelector([selectScreenRefDataMap, selectDisplayRuleStateMap], (screenRefDataMap, displayRuleStateMap) => {
    if (!screen || !action) {
      return false;
    }
    const refDataInitialized = !!screenRefDataMap[screen];
    const displayRulesInitialized =
      !!displayRuleStateMap[ExpEngine.getDisplayRuleService().getDisplayRuleKey(screen, action)];
    return refDataInitialized && displayRulesInitialized;
  });
